import { render } from "./PanelClienteHistorial.vue?vue&type=template&id=65ffd1e4&scoped=true"
import script from "./PanelClienteHistorial.vue?vue&type=script&lang=js"
export * from "./PanelClienteHistorial.vue?vue&type=script&lang=js"

import "./PanelClienteHistorial.vue?vue&type=style&index=0&id=65ffd1e4&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ffd1e4"]])

export default __exports__